/**
Copyright (C) 2019-2022, Infraclear Inc. All Rights Reserved.
*/

import React from 'react';
import Cookies from 'js-cookie';
import { docSearchBasePath } from '../constants/env-url';

interface GuestGuardedRouteProps {
    children: React.ReactChild,
}
const GuestGuardedRoute: React.FC<GuestGuardedRouteProps> = (props: any) => {
    const { children } = props;

    if (Cookies.get('auth') !== undefined && Cookies.get('auth') === 'false' && Cookies.get('guest-auth') === 'true') {
        return window.location.href = `${docSearchBasePath}`;;
    }

    return children;
};

export default GuestGuardedRoute;